export function formatMapCoordinates(lat: number, lng: number) {
	return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
}

export function getGoogleMapsUrl(lat: number, lng: number) {
	return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

export function getWazeUrl(lat: number, lng: number) {
	return `https://www.waze.com/ul?ll=${lat}%2C${lng}&navigate=yes`;
}
